<mga-notification
    *ngFor="let notification of notifications"
    [notification]="notification"
    (terminated)="onTerminate(notification)"
></mga-notification>
